
	import { Observer } from 'mobx-vue';
	import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
	import PrescriptionItem from '@/components/new-prescription/prescription-items/PrescriptionItem.vue';
	import PrescriptionItemWrapper from '@/components/new-prescription/prescription-items/PrescriptionItemWrapper.vue';
	import PrescriptionItemSpecialRXTile from '@/components/new-prescription/prescription-items/PrescriptionItemSpecialRXTile.vue';

	@Observer
	@Component({
		components: { PrescriptionItemWrapper, PrescriptionItemSpecialRXTile }
	})
	export default class PrescriptionItemSelect extends Vue {
		@PropSync('specialRX', { required: true }) special!: string[];
		@Prop({ required: true }) predefinedSpecialRX!: string[];
		@Prop({ required: false }) specialBreakdown: boolean = false;
		filteredPredefinedSpecialRX: string[] = [];
		// specialBreakdown: boolean = true;
		specialBreakdownArray: string[][] = [];

		// isInputActive(e) {
		// 	if (e.target.localName.includes('label')) {
		// 		let path = e.composedPath();
		// 		if (this.specialBreakdown) {
		// 			path[1].className += ' item-container-disable';
		// 			setTimeout(() => {
		// 				if (path[1].className.includes('active')) {
		// 					path[1].className = 'item-container';
		// 				} else {
		// 					path[1].className = 'item-container item-container-active';
		// 				}
		// 			}, 400);
		// 		} else {
		// 			path[2].className += ' item-container-disable';
		// 			setTimeout(() => {
		// 				if (path[2].className.includes('active')) {
		// 					path[2].className = 'item-container';
		// 				} else {
		// 					path[2].className = 'item-container item-container-active';
		// 				}
		// 			}, 400);
		// 		}
		// 	}
		// }

		// updateOtherServicesButtonsMode() {
		// 	this.$refs.itemContainer.forEach((i) => {
		// 		i.className = 'item-container';
		// 		console.log('this special', this.special)
		// 		this.special.forEach((s) => {
		// 			if (s === i.innerText) i.className = 'item-container item-container-active';
		// 		});
		// 	});
		// }

		checkRef() {
			// this.updateOtherServicesButtonsMode();
			if ((this.$refs['userPanelMainContents'] as HTMLElement).className === 'main-container') {
				(this.$refs['userPanelMainContents'] as HTMLElement).className = 'main-container-hover';
				(this.$refs['chevronIcon'] as HTMLElement).className = 'chevron-icon-rotate';
			} else {
				(this.$refs['userPanelMainContents'] as HTMLElement).className = 'main-container';
				(this.$refs['chevronIcon'] as HTMLElement).className = 'chevron-icon';
			}
		}

		mounted() {
			this.filteredPredefinedSpecialRX = this.predefinedSpecialRX.filter((item) => item !== 'Hourglass the shell');
			this.specialBreakdownArray.push(this.filteredPredefinedSpecialRX.slice(0, 4));
			this.specialBreakdownArray.push(this.filteredPredefinedSpecialRX.slice(4, 9));
			this.specialBreakdownArray.push(this.filteredPredefinedSpecialRX.slice(9, 10));
			this.specialBreakdownArray.push(this.filteredPredefinedSpecialRX.slice(10));
			// this.updateOtherServicesButtonsMode();
		}
		activated() {
			// this.updateOtherServicesButtonsMode();
		}
	}
